import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UtilityService } from 'src/app/services/utility.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import * as moment from 'moment';
import { RegionService } from 'src/app/services/region.service';
import { DivisionService } from 'src/app/services/division.service';
import { SubDivisionService } from 'src/app/services/subdivision.service';
import { AlertService } from 'src/app/services/alert.service';
import { ReportsService } from 'src/app/services/reports.service';
import { TripEntryService } from 'src/app/services/tripentry.service';
import { ShowDailyReportComponent } from '../showdailyreport/showdailyreport.component';
import { UserSessionService } from 'src/app/services/usersession.service';
import { RoleType } from 'src/enum/roletype';
import { DateTimeAdapter } from 'ng-pick-datetime';
import * as _ from 'lodash';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-machinery-wise-report',
  templateUrl: './machinery-wise-report.component.html',
  styleUrls: ['./machinery-wise-report.component.scss']
})
export class MachineryWiseReportComponent implements OnInit {
  form: FormGroup;
  dropdownSettings: any = {};
  vehicleList: any = [];
  tripTypeList: any[];
  CategoryTypeList: any[];
  url: string;
  // clientId: any;
  scheduledEndmin: any;
  scheduledEndmax: any;
  vehicleRegNo: any;
  maxDate: Date;
  registrationNumbers: any[];
  regionList: any[];
  subdivisionList: any[];
  VehicleRegNoList: any[];
  divisionList: any[];
  filterregionList: any[];
  filterdivisionList: any[];
  filtersubdivisionList: any[];
  filterListsubdivisionList: any[];
  VehicleTypeList: any[];
  filterVehicleTypeList: any[];
  public RoleEnumType = RoleType;
  roleId: number;
  accessAssEng: boolean;
  paymentList: any[];
  filterpaymentList: any[];

  constructor(
    private formBuilder: FormBuilder, 
    private reportsService: ReportsService,
    private alertService: AlertService,
    private vehicleService: VehicleService,
    private utilityService: UtilityService,
    public tripDialog: MatDialog,
    private regionService: RegionService,
    private divisionService: DivisionService,
    private tripEntryService: TripEntryService,
    private subdivisionService: SubDivisionService,
    private userSessionService: UserSessionService,
    dateTimeAdapter: DateTimeAdapter<any>) {
      dateTimeAdapter.setLocale('en-IN')
      //  this.clientId = this.userSessionService.getCurrentClientId();
      this.registrationNumbers = [];
      this.regionList = [];
      this.divisionList = [];
      this.subdivisionList = [];
      this.VehicleRegNoList = [];
      this.filterregionList = [];
      this.filterdivisionList = [];
      this.filtersubdivisionList = [];
      this.VehicleTypeList = [];
      this.filterVehicleTypeList = [];
      this.roleId = this.userSessionService.roleId();
      this.paymentList = [];
      this.filterpaymentList = [];
      // this.accessAssEng = this.roleId === this.RoleEnumType.AssistantEngineer;
     }

     ngOnInit() {
      this.initializeValidators();
      this.getLookupRegion(true);
      this.getVehicleType();
      this.getLookupPayment();
      this.dropdownSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'regNo',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true
      };
      this.maxDate = new Date();
      this.scheduledEndmax = new Date();
  
  
    }
  
    initializeValidators() {
      this.form = this.formBuilder.group({
        ScheduledStart: ['', Validators.required],
        ScheduledEnd: ['', Validators.required],
        VehicleRegNo: [null],
        regionId: [null],
        divisionId: [null],
        subDivisionId: [null],
        vehicleTypeId: [null],
        paymentId: [null]
      });
    }
  
    validateFormControl() {
      Object.keys(this.form.controls).forEach(field => {
        const control = this.form.get(field);
        if (control instanceof FormControl) {
          control.markAsTouched({
            onlySelf: true
          });
        }
      })
    }
  
  
    getLookupRegion(refresh: boolean) {
      this.regionService.getLookUp(refresh).subscribe(result => {
        if (result) {
          this.regionList = [];
          this.filterregionList = [];
          this.regionList = result;
          this.filterregionList = this.regionList.slice();
          const regionLength = this.regionList.length;
          if (regionLength === 1) {
            this.form.controls['regionId'].setValue(this.regionList[0].key);
            this.getLookupDivision(this.form.value.regionId);
          }
        }
      })
    }
  
    regionChange() {
      this.getLookupDivision(this.form.value.regionId);
      this.form.controls['divisionId'].setValue(0);
      this.form.controls['subDivisionId'].setValue(0);
      this.form.controls['vehicleTypeId'].setValue(0);
      this.form.controls['VehicleRegNo'].setValue(0);
    }
    getLookupDivision(id) {
      this.divisionService.getLookUpbyId(true, id).subscribe(result => {
        if (result) {
          this.divisionList = [];
          this.filterdivisionList = [];
          this.divisionList = result;
          this.filterdivisionList = this.divisionList.slice();
          const divisionLength = this.divisionList.length;
          if (divisionLength === 1) {
            this.form.controls['divisionId'].setValue(this.divisionList[0].key);
            this.getLookupSubDivision(this.form.value.divisionId);
          }
        }
      })
    }
    divisionChange() {
      this.getLookupSubDivision(this.form.value.divisionId);
      this.form.controls['subDivisionId'].setValue(0);
      this.form.controls['vehicleTypeId'].setValue(0);
      this.form.controls['VehicleRegNo'].setValue(0);
    }
    getLookupSubDivision(id) {
      this.subdivisionService.getLookUpbyId(true, id).subscribe(result => {
        if (result) {
          this.subdivisionList = [];
          this.filterListsubdivisionList = [];
          this.subdivisionList = result;
          this.filterListsubdivisionList = this.subdivisionList.slice();
          const subdivisionLength = this.subdivisionList?.length;
          if (subdivisionLength === 1) {
            this.form.controls['subDivisionId'].setValue(this.subdivisionList[0].key);
            this.getVehicleList(this.form.value.subDivisionId, true);
          }
        }
      })
    }
    subDivisionChange() {
      this.form.controls['vehicleTypeId'].setValue(0);
      this.form.controls['VehicleRegNo'].setValue(0);
      this.getVehicleList(this.form.value.subDivisionId, true);
    }
    getVehicleType() {
      this.tripEntryService.getVehicleTypeLookup(true).subscribe(res => {
        if (res) {
          this.VehicleTypeList = [];
          this.filterVehicleTypeList = [];
          this.VehicleTypeList = res;
          this.filterVehicleTypeList = this.VehicleTypeList.slice();
        }
      });
    }
  
  
    vehicleTypeChange() {
      this.VehicleRegNoList = [];
      this.form.controls['VehicleRegNo'].setValue(null)
      this.VehicleRegNoList = this.registrationNumbers;
      const vehicleTypeId = this.VehicleRegNoList.filter(e => {
        return e.categoryType === this.form.value.vehicleTypeId
      })
      if (vehicleTypeId) {
        this.VehicleRegNoList = vehicleTypeId;
      } else {
        this.VehicleRegNoList = this.registrationNumbers;
      }
    }
    getVehicleList(id: number, refresh: boolean) {
      const postData = {
        subdivisionId:id,
        start: moment(this.form.value.ScheduledStart).format('YYYY-MM-DD'),
        end: moment(this.form.value.ScheduledEnd).format('YYYY-MM-DD'),
      }
      this.vehicleService.getVehicleLookUpfforreport(postData, refresh).subscribe(result => {
        if (result) {
          this.registrationNumbers = [];
          this.registrationNumbers = result;
          const length = this.registrationNumbers.length;
          this.registrationNumbers.forEach(element => {
            element.regNo = element.regNo + ' - ' + element.vehicleTypeName;
          });
          if (length === 1) {
            // this.form.controls['vehicleId'].setValue(this.registrationNumbers[0].id);
            this.form.controls['vehicleTypeId'].setValue(this.registrationNumbers[0].vehicleType);
          }
        }
      });
    }
    setDate() {
      if(this.form.value.ScheduledEnd){
        this.form.controls['ScheduledEnd'].setValue(null);
      }
      const currDate = moment(new Date()).format('YYYY-MM-DD');
      const yesterday = moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD');
      const chooseDate = moment(this.form.value.ScheduledStart).format('YYYY-MM-DD');
      // if (chooseDate === currDate) {
      //   this.scheduledEndmin = this.form.value.ScheduledStart;
      //   this.scheduledEndmax = moment(this.form.value.ScheduledStart).format('YYYY-MM-DD');
      // } else if (chooseDate === yesterday) {
      //   this.scheduledEndmin = this.form.value.ScheduledStart;
      //   this.scheduledEndmax = moment(this.form.value.ScheduledStart).add(1, 'days').format('YYYY-MM-DD');
      // } else {
      //   this.scheduledEndmin = this.form.value.ScheduledStart;
      //   this.scheduledEndmax = moment(this.form.value.ScheduledStart).add(2, 'days').format('YYYY-MM-DD');
      // }
  
      const dcurr = moment(new Date(), "DD.MM.YYYY");
      const dchoose = moment(this.form.value.ScheduledStart, "DD.MM.YYYY");
      const datediff = dcurr.diff(dchoose, 'days');
      // if(datediff == 31 || datediff < 31){
      //   // this.scheduledEndmax = moment(new Date()).format('YYYY-MM-DD');
      //   this.scheduledEndmax = moment(this.form.value.ScheduledStart).add(31, 'days').format('YYYY-MM-DD');
      // }else if(datediff > 31){
      //   if(this.form.value.ScheduledEnd)
      //   this.form.controls['ScheduledEnd'].setValue(null);
      //   this.scheduledEndmin = this.form.value.ScheduledStart;
      //   this.scheduledEndmax = moment(this.form.value.ScheduledStart).add(31, 'days').format('YYYY-MM-DD');
      // }
      this.scheduledEndmax = moment(new Date()).add(0, 'days').format('YYYY-MM-DD');
  
  
  
  
  
  
  
    }
  
    getTripType() {
      this.utilityService.getTripTypeLookUp(true).subscribe(res => {
        if (res) {
          this.tripTypeList = [];
          this.tripTypeList = res;
        }
      });
    }
  
    getCategoryType() {
      this.utilityService.getTransportTypeLookup(true).subscribe(res => {
        if (res) {
          this.CategoryTypeList = [];
          this.CategoryTypeList = res;
        }
      });
    }
  
    CategoryNameChange() {
      this.vehicleRegNo = [];
      this.vehicleRegNo = this.vehicleList.filter(e => {
        return e.transportCategoryId === this.form.value.CategoryName;
      })
    }
  
    clear() {
      if(this.roleId === this.RoleEnumType.AssistantEngineer){
        this.form.controls['ScheduledStart'].setValue(null);
        this.form.controls['ScheduledEnd'].setValue(null);
        this.form.controls['vehicleTypeId'].setValue(null);
        this.form.controls['VehicleRegNo'].setValue(null);
      this.form.controls['paymentId'].setValue(null);
      }
      if( this.roleId === this.RoleEnumType.AssistantExecutiveEngineer){
        this.form.controls['ScheduledStart'].setValue(null);
        this.form.controls['ScheduledEnd'].setValue(null);
        this.form.controls['vehicleTypeId'].setValue(null);
        this.form.controls['VehicleRegNo'].setValue(null);
        this.form.controls['paymentId'].setValue(null);
      }
      if(this.roleId === this.RoleEnumType.ExecutiveEngineer){
        this.form.controls['ScheduledStart'].setValue(null);
        this.form.controls['ScheduledEnd'].setValue(null);
        this.form.controls['vehicleTypeId'].setValue(null);
        this.form.controls['VehicleRegNo'].setValue(null);
        this.form.controls['subDivisionId'].setValue(null);
      this.form.controls['paymentId'].setValue(null);
      }
      if(this.roleId === this.RoleEnumType.SuperintendEngineer){
        this.form.controls['ScheduledStart'].setValue(null);
        this.form.controls['ScheduledEnd'].setValue(null);
        this.form.controls['vehicleTypeId'].setValue(null);
        this.form.controls['VehicleRegNo'].setValue(null);
        this.form.controls['divisionId'].setValue(null);
        this.form.controls['subDivisionId'].setValue(null);
      this.form.controls['paymentId'].setValue(null);
      }
      if(this.roleId === this.RoleEnumType.Foreman){
        this.form.controls['ScheduledStart'].setValue(null);
        this.form.controls['ScheduledEnd'].setValue(null);
        this.form.controls['vehicleTypeId'].setValue(null);
        this.form.controls['VehicleRegNo'].setValue(null);
      this.form.controls['paymentId'].setValue(null);
      }
      if(this.roleId === this.RoleEnumType.SuperAdmin ||
        this.roleId === this.RoleEnumType.ChiefEngineer ||
        this.roleId === this.RoleEnumType.SeniorEngineer ||
        this.roleId === this.RoleEnumType.Root  ){
        this.initializeValidators();
      }
      // else{
      //   this.initializeValidators();
      // }
     
    }
  
    showReport() {
      if (this.form.valid) {
        if (this.form.value.regionId == null) {
          this.form.controls['regionId'].setValue(0);
        }
        if (this.form.value.divisionId == null) {
          this.form.controls['divisionId'].setValue(0);
        }
        if (this.form.value.subDivisionId == null) {
          this.form.controls['subDivisionId'].setValue(0);
        }
        if (this.form.value.vehicleTypeId == null) {
          this.form.controls['vehicleTypeId'].setValue(0);
        }
        if (this.form.value.VehicleRegNo == null) {
          this.form.controls['VehicleRegNo'].setValue(0);
        }
        if (this.form.value.paymentId == null) {
          this.form.controls['paymentId'].setValue(0);
        }
        const vehicleIdList = [];
        let startDate = this.form.get('ScheduledStart').value;
        let endDate = this.form.get('ScheduledEnd').value;
        const selectedVehicle = this.form.get('VehicleRegNo').value;
        startDate = moment(startDate).format('YYYY-MM-DD');
        endDate = moment(endDate).format('YYYY-MM-DD');
        if (selectedVehicle && selectedVehicle.length > 0) {
          selectedVehicle.forEach(element => {
            vehicleIdList.push(element.id);
          });
        }
  
  
        const data = {
          startTs: startDate,
          endTs: endDate,
          vehicleId: vehicleIdList,
          divisionId: this.form.value.divisionId,
          regionId: this.form.value.regionId,
          subDivisionId: this.form.value.subDivisionId,
          vehicleTypeId: this.form.value.vehicleTypeId,
          paymentId: this.form.value.paymentId,
          ReportType: 25
        }
        // const data = {
        //   clientId: 1,
        //   startTs: '2020-11-20',
        //   endTs: '2020-11-27',
        //   vehicleId: [1,2],
        //   tripType: 1,
        //   reportType: 2,
        //   downloadType: 1
        // }
        const dialogRef = this.tripDialog.open(ShowDailyReportComponent, {
          autoFocus: false,
          disableClose: true,
          width: '100%',
          height: '90%',
          panelClass: 'mat-dialog-bookingreport',
          data
        })
        dialogRef.afterClosed().subscribe(() => {
        });
      } else {
        this.validateFormControl();
      }
    }
  
    
    getLookupPayment() {
      this.divisionService.getLookUpPayment(true).subscribe(result => {
        if (result) {
          this.paymentList = [];
          this.filterpaymentList = [];
          this.paymentList = result;
          this.filterpaymentList = this.paymentList.slice();
          const divisionLength = this.paymentList.length;
          if (divisionLength === 1) {
            this.form.controls['divisionId'].setValue(this.paymentList[0].key);
          }
        }
      })
    }
}
